<template>
    <div class="text-center">
        <v-row>
            <v-col>
                <h2>Meine Termine</h2>
                <p>- Kurzübersicht -<br />
                    (nur Essen & Wäsche).<br />
                    <router-link to="/plan">Alle Termine</router-link></p>
                <v-data-table
                    v-if="$store.getters.getUser.planUsers"
                    :headers="headers"
                    :items="plans"
                    :loading="isLoading"
                    :custom-sort="sortItems"
                    hide-default-footer
                    hide-default-header
                    class="indigo--text"
                >
                    <template v-slot:item.date="{ item }">
                        {{ formatDate(item.date) }}
                    </template>
                    <template v-slot:item.name="{ item }">
                        <v-row
                            v-if="isFoodDay(item.date)"
                            class="align-center"
                        >
                            <v-col class="col-2">
                                <v-icon
                                    class="cyan--text"
                                    large
                                >
                                    mdi-food-fork-drink
                                </v-icon>
                            </v-col>
                            <v-col>
                                <h2>
                                    <span>{{ getName(item.upid, item.swapped_upid) }}</span>
                                </h2>
                            </v-col>
                        </v-row>
                        <v-row
                            v-else
                            class="align-center"
                        >
                            <v-col class="col-2">
                                <v-icon
                                    class="[ pink--text  text--lighten-2 ]"
                                    large
                                >
                                    mdi-washing-machine
                                </v-icon>
                            </v-col>
                            <v-col>
                                <h2>
                                    <span>{{ getName(item.upid, item.swapped_upid) }}</span>
                                </h2>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-table>
                <v-alert v-else
                         outlined
                         type="warning"
                         prominent
                         border="left"
                >
                    Du hast keine Kind-Zugehörigkeit. Daher werden hier keine Termine angezeigt.
                </v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import moment from 'moment'
import PlanService from '@/services/PlanService'

export default {
    name: 'MyPlan',
    data() {
        return {
            headers: [
                {
                    text: 'Datum',
                    align: 'start',
                    value: 'date',
                },
                {
                    text: 'Familie',
                    align: 'start',
                    value: 'name',
                },
            ],
            isLoading: false,
            plans: []
        }
    },
    async created() {
        this.getPlans()
    },
    methods: {
        async getPlans() {
            const currDate = this.date ? moment(this.date) : moment()
            const year =  currDate.format('YYYY')
            if (this.$store.getters.getUser.planUsers) {
                for (const planUser of this.$store.getters.getUser.planUsers) {
                    const plans = await PlanService.getPlansUser(planUser.puid, year)
                    this.plans = this.plans.concat(plans)
                }
                this.plans = this.plans.filter(plan => moment(plan.date, 'DD.MM.YYYY', 'de').isSameOrAfter(moment()))
            }
        },
        formatDate(date) {
            date = moment(date, 'DD.MM.YYYY', 'de')
            if (date.weekday() === 5) {
                const datePlusOne = date.clone().add(1, 'days')
                return `${date.format('dd. DD.MM.')} / ${datePlusOne.format('dd. DD.MM.YYYY')}`
            } else if (date.weekday() === 6) {
                const dateMinusOne = date.clone().add(-1, 'days')
                return `${dateMinusOne.format('dd. DD.MM.')} / ${date.format('dd. DD.MM.YYYY')}`
            } else {
                return date.format('dd. DD.MM.YYYY')
            }
        },
        getName (upid, swappedUpid) {
            const id = swappedUpid ? swappedUpid : upid
            const user = this.$store.getters.getUser.planUsers.find(planUser => planUser.puid === id)
            return user ? user.name : ''
        },
        isFoodDay(date) {
            date = moment(date, 'DD.MM.YYYY', 'de')
            return date.weekday() < 5
        },
        sortItems(items) {
            if (!items.length) return []
            return items.sort((a, b) => {
                const dateA = moment(a.date, 'DD.MM.YYYY', 'de')
                const dateB = moment(b.date, 'DD.MM.YYYY', 'de')
                return dateA.diff(dateB)
            })
        }
    }
}
</script>
